<template>
  <div :class="$attrs.class">
    <div class="max-w-screen-xl m-auto">
      <form @submit.prevent="update">
      <div class="flex flex-wrap mb-4 mr-6 p-8 bg-white rounded-lg shadow overflow-hidden">
        <h1 class="pb-8 pr-6 w-full text-xl font-bold">{{ form.title }}</h1>
        <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full font-bold lg:w-1/2" label="Title" />
        <text-input v-model="form.subject" :error="form.errors.subject" class="pb-8 pr-6 w-full font-bold lg:w-1/2" label="Subject" />
        <div class="pr-6 w-full">
          <ckeditor v-model="form.message" :error="form.errors.message" :editor="editor" :config="editorConfig" @ready="onEditorReady" />
          <div v-if="form.errors.message" class="form-error font-bold">{{ form.errors.message }}</div>
        </div>
        <div class="pb-4 w-full">
              <attachment-uploader :initial-attachment-url="form.attachment" message-type="email" @update:attachmentUrl="updateAttachmentUrl" @update:attachmentName="updateAttachmentName"/>
            </div>
        <div class="text-m mt-2 w-full text-left">
          <span class="tag-input__tag text-sm cursor-pointer">Insert Lead Fields</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%first%')">first name</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%fullName%')">full name</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%phone%')">phone</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%email%')">email</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%fullNameCoborrower%')">co-full name</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%phoneCoborrower%')">co-phone</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%emailCoborrower%')">co-email</span>
        </div>
        <div class="text-m mt-2 pb-2 w-full text-left">
          <span class="tag-input__tag text-sm cursor-pointer">Insert User Fields</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_first_name%')">first name</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_last_name%')">last name</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_phone%')">phone</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_email%')">email</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_application_link%')">app link</span>
          <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_appointment_link%')">appointment</span>
        </div>
        <button class="px-2 py-2 text-red-600 text-xl cursor-pointer" tabindex="-1" type="button" @click="destroy"><i class="far fa-trash-alt ml-2 text-red-500" /></button>
        <loading-button :loading="form.processing" class="btn-indigo mb-4 ml-auto cursor-pointer">Update Template</loading-button>
      </div>
    </form>
    </div>
  </div>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import ClassicEditor from '../Plugin/CKEditor/ckeditor.js'
import AttachmentUploader from '@/Shared/AttachmentUploader'
import { router } from '@inertiajs/vue3'

export default {
  components: {
    TextInput,
    // TextareaInput,
    LoadingButton,
    AttachmentUploader,
  },
  inheritAttrs: false,
  props: {
    template: Object,
  },
  // remember: 'form',
  data() {
    return {
      form: router.form({
        title: this.template.title,
        subject: this.template.subject,
        message: this.template.message,
        id: this.template.id,
        attachment: this.template.attachment,
        attachmentName: this.template.attachmentName,
      }),
      attachmentError:'',
      toggle: false,
      editor: ClassicEditor,
      editorConfig: {
        // plugins: [ SpecialCharacters ],
        toolbar: {
          items: [
            'heading',
            {
              // This drop-down has the icon disabled and a text label instead.
              label: 'Font',
              icon: false,
              items: [
                'bold',
                'italic',
                'fontSize',
                'fontColor',
                'fontBackgroundColor',
                'underline',
                'strikethrough',
              ],
            },
            {
              // This drop-down has the icon disabled and a text label instead.
              label: 'Format',
              icon: false,
              items: [
                'blockQuote',
                'bulletedList',
                'numberedList',
                'outdent',
                'indent',
              ],
            },
            '|',
            'imageInsert',
            'link',
            '|',
            // 'fontSize',
            // 'horizontalLine',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
            'sourceEditing',
          ],
        },
        language: 'en',
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
        },
        mediaEmbed: {
          previewsInData: true,
        },
        removePlugins: ['MediaEmbedToolbar'],
        simpleUpload: {
          // The URL that the images are uploaded to.
          uploadUrl: '/emailMass/uploadCKImage',
        },
      },
    }
  },
  methods: {
    onEditorReady(editor) {
      this.editor = editor
    },
    insertField(token) {
      this.editor.model.change((writer) => {
        writer.insertText(token, this.editor.model.document.selection.getFirstPosition())
      })
      this.editor.focus()
    },
    // insertField(field) {
    //   this.form.message = this.form.message + field
    // },
    // update() {
    // var postTo = '/emailTemplates/'+this.template.id
    // router.put(postTo, this.form, {
    //   preserveScroll: true,
    // })
    // },
    removeAttachment() {
      this.form.attachment=null
      this.form.attachmentName=null
    },
    isImage(url) {
      // Regular expression to match common image extensions
      const imageExtensions = /\.(jpg|jpeg|png|gif)$/i;
      return imageExtensions.test(url);
    },
    updateAttachmentUrl(url) {
      this.form.attachment = url
    },
    updateAttachmentName(name) {
      this.form.attachmentName = name
    },
    update() {
      this.form.put('/emailTemplates/' + this.template.id, {
        preserveScroll: true,
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this template?')) {
        router.delete('/emailTemplates/' + this.template.id, { preserveScroll: true })
      }
    },
  },
}
</script>
<style>
.ck-editor__editable {
  min-height: 120px;
  line-height: 1em;
}
.ck-editor__editable_inline {
    padding: 0 30px !important;
}
.ck-content p {
  /* line-height: 1.6 !important; */
  margin-bottom: 1em;
}
.ck-content img {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  width: unset;
  height: unset;
  display: block;
}
.tag-input__tag {
  height: 30px;
  float: left;
  margin-right: 10px;
  /* background-color: #eee; */
  margin-top: 10px;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 5px;
}
.tag-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
}
</style>
